import { defineMessages } from 'react-intl';

import { FormStates } from './constants';

export const modalTitleMessages = defineMessages({
  [FormStates.Form]: {
    description: 'Title to create an API Key V1',
    id: 'Vjjus0',
    defaultMessage: 'Generate API Key',
  },
  [FormStates.Summary]: {
    description: 'Title after creating the V1 API Key',
    id: 'DUxQMf',
    defaultMessage: 'API Key Created',
  },
  [FormStates.LastCall]: {
    defaultMessage: 'All Set?',
    id: 'ydZTsd',
    description: 'Title warning the user to copy the keys',
  },
});

export const modalActionButtonMessages = defineMessages({
  [FormStates.Form]: {
    description: 'Button label to generate an API Key V1',
    id: 'l6UGsn',
    defaultMessage: 'Generate',
  },
  [FormStates.Summary]: {
    description: 'Button label when the user wants to close the summary',
    id: 'BnWVaR',
    defaultMessage: 'Done',
  },
  [FormStates.LastCall]: {
    defaultMessage: 'I need to copy it again',
    id: 'epm7TQ',
    description: 'Button label for a button to go back to the form',
  },
});

export const modalCancelButtonMessages = defineMessages({
  [FormStates.Form]: {
    description: 'Button label to cancel and close the modal',
    id: 'UecC77',
    defaultMessage: 'Cancel',
  },
  [FormStates.LastCall]: {
    defaultMessage: 'Yes, I’ve saved it',
    id: '7FTiD7',
    description: 'Button label to close the modal',
  },
});
